export const LogoSVG = () => (
  <svg width='30' height='40' viewBox='0 0 61 104'>
    <g id='_03' data-name='03'>
      <g id='Logo-harold' transform='translate(0 0)'>
        <g id='Group-2' transform='translate(0)'>
          <g id='Icon-Harold'>
            <path
              id='Path'
              d='M59.712,85.2l-57.264,18.7A1.868,1.868,0,0,1,0,102.131V47.425a1.246,
               1.246,0,0,1,.814-1.169L58.142,25.077a1.246,1.246,0,0,1,1.677,1.143L61,
                83.39A1.869,1.869,0,0,1,59.712,85.2Z'
              transform='translate(0 0)'
              fill='#8ecbff'
            ></path>
            <path
              id='Path-2'
              data-name='Path'
              d='M2,63.37,58.465,84.877a1.87,1.87,0,0,0,2.411-1.072A1.851,1.851,0,0,0,61,
              83.141V23.92a1.859,1.859,0,0,0-1.193-1.733L2.541.126A1.87,1.87,0,0,0,.126,
              1.188,1.851,1.851,0,0,0,0,1.859V60.477A3.1,3.1,0,0,0,2,63.37Z'
              transform='translate(0 0)'
              fill='#4d30ef'
            ></path>
            <g id='Group' transform='translate(0 22.069)'>
              <path
                id='Path-3'
                data-name='Path'
                d='M60.836,62.047V1.472A1.242,1.242,0,0,0,60.043.314L59.412.069,
                 1.611,21.76A2.485,2.485,0,0,0,0,24.087V38.918a2.485,2.485,0,0,0,
                  1.594,2.32L59.088,63.317l.909-.3A1.242,1.242,0,0,0,60.836,62.047Z'
                transform='translate(0 -0.069)'
                fill='#3a0d98'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);


